import React, { useRef, useState } from "react";
import { useEffect } from "react";
import ReactPaginate from "react-paginate";
import Button from "@mui/material/Button";
import { Box, Paper } from "@mui/material";

import Records from "./Records";
import useHttp from "../../../Hooks/use-http";
import Modal from "../../../GeneratePDF/Modal";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import DateFilter from "../../CommonComponent/DateFilterByMUI";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CommonTablePagination from "../../CommonComponent/CommonTablePagination";
import { PAGINATIONBASEVALUE } from "../../../Constant";
import PortalTitle from "../../CommonComponent/PortalTitle";

const SHIFT_TITLE = [
  "ID",
  "Corporate Name",
  "Guest Details",
  "Pickup Date",
  "Drop Date",
  "Booking Type",
  "Vehicle Type",
  "Trip Cost",
  "Status",
];

let myClick = false;
let prev_id = "1";
let total_shift_data = "";
let today = new Date()
  .getFullYear()
  .toString()
  .concat("-", new Date().getMonth() + 1, "-", new Date().getDate());
let startDate = today;
let endDate = today;

function PreviousBookings(props) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(PAGINATIONBASEVALUE);
  const [filteredData, setFilteredData] = useState([]);
  const [isDataFiltered, setIsDataFiltered] = useState(true);
  const [isExportButtonClicked, setIsExportButtonClicked] = useState(false);
  const [startDateValue, setStartDateValue] = useState(dayjs(new Date()));
  const [endDateValue, setEndDateValue] = useState(dayjs(new Date()));
  const startDateRef = useRef();
  const endDateRef = useRef();
  const history = useHistory();

  const authenticateUser = (data) => {
    let booking_list = [];
    if (data?.RequestBookingDetails) {
      for (let i = 0; i < data?.RequestBookingDetails.length; i++) {
        booking_list.push({
          id: i + 1,
          bookingId: data?.RequestBookingDetails[i].BookingID,
          guestName: data?.RequestBookingDetails[i].GuestName,
          guestMobile: data?.RequestBookingDetails[i].GuestMobileNumber,
          bookingDate:
            data?.RequestBookingDetails[i].BookingDateTime?.split("T")[0] +
            " " +
            data?.RequestBookingDetails[i].BookingDateTime?.split(
              "T"
            )[1]?.slice(0, 5),
          pickupDate:
            data?.RequestBookingDetails[i].PickupDateTime?.split("T")[0],
          pickupTime: data?.RequestBookingDetails[i].PickupDateTime?.split(
            "T"
          )[1]?.slice(0, 5),
          dropDate: data?.RequestBookingDetails[i].EndedOn?.split("T")[0],
          dropTime: data?.RequestBookingDetails[i].EndedOn?.split(
            "T"
          )[1]?.slice(0, 5),
          pickupLocation: data?.RequestBookingDetails[i].PickupAddress,
          dropLocation: data?.RequestBookingDetails[i].DropoffAddress,
          vehicleType: data?.RequestBookingDetails[i].VehicleType,
          status: data?.RequestBookingDetails[i].Status,
          driverName: data?.RequestBookingDetails[i].DriverName,
          driverCarModel: data?.RequestBookingDetails[i].carModel,
          driverCarNumber: data?.RequestBookingDetails[i].carNumber,
          cancelNotes: data?.RequestBookingDetails[i].CancelNotes,
          bookingType: data?.RequestBookingDetails[i].Justification,
          corporateName: data?.RequestBookingDetails[i].CorporateName,
          coprorateId: data?.RequestBookingDetails[i].AdminDepartmentID,
          driverCost: data?.RequestBookingDetails[i].DriverCost,
          driverEmailId: data?.RequestBookingDetails[i].DriverEmailId,
          companyCost: data?.RequestBookingDetails[i].CompanyCost,
          tripOtp: {
            isOtpEnabled: data?.RequestBookingDetails[i].isOTPEnabled,
            startOtp: data?.RequestBookingDetails[i].StartTripOTP,
            endOtp: data?.RequestBookingDetails[i].EndTripOTP,
          },
        });
      }
    }
    total_shift_data = booking_list;
    setFilteredData(booking_list);
    setIsDataFiltered(false);
  };

  const { isLoading, sendRequest } = useHttp();

  useEffect(() => {
    if (isDataFiltered) {
      setFilteredData([]);
      sendRequest(
        {
          // url: "/api/v1/ScheduleBooking/GetBookingRequestDetails",
          url: "/schedulebookings",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            // emailID: localStorage.getItem("user"),
            corporateID: localStorage.getItem("corpId"),
            startDate: `${startDateValue.$d.getFullYear()}/${
              startDateValue.$d.getMonth() + 1
            }/${startDateValue.$d.getDate()}`,
            endDate: `${endDateValue.$d.getFullYear()}/${
              endDateValue.$d.getMonth() + 1
            }/${endDateValue.$d.getDate()}`,
            // roleID: localStorage.getItem("roleId"),
          },
        },
        authenticateUser
      );
    }
  }, [sendRequest, isDataFiltered]);

  const nPages = Math.ceil(filteredData.length / rowsPerPage);

  let fromRecords = 0;
  if (page === 0) fromRecords = 1;
  else fromRecords = page * rowsPerPage;
  let toRecords = 0;
  if (
    (myClick
      ? page * rowsPerPage - (filteredData.length % rowsPerPage)
      : page * rowsPerPage +
        rowsPerPage -
        (filteredData.length % rowsPerPage)) > filteredData.length
  )
    toRecords = filteredData.length;
  else toRecords = page * rowsPerPage;
  if (toRecords === 0) fromRecords = 0;
  if (page === nPages) toRecords = filteredData.length;

  // Calculate pagination
  const indexOfLastRecord = page * rowsPerPage + rowsPerPage;
  const indexOfFirstRecord = page * rowsPerPage;
  const currentRecords = filteredData.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  return (
    <div className="trips-details" id="trip-table">
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          marginTop: 0,
          paddingTop: 0,
        }}
      >
        <div className="table-container" style={{ marginTop: 0, paddingTop: 0 }}>
          <Paper
            sx={{
              width: "100%",
              mb: 2,
              borderRadius: "10px",
              flex: 1,
              display: "flex",
              flexDirection: "column",
              border: "none",
              borderBottom: "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                px: 2,
                pt: 1,
                pb: 1,
                borderRadius: "10px",
                flexDirection: { xs: "column", md: "row" },
                gap: { xs: 1, md: 0 },
              }}
            >
              <Box component="h2" sx={{ m: 0, display: "flex", alignItems: "center", minWidth: 0, flexShrink: 0 }}>
                <PortalTitle fallback="Previous Bookings" />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: "12px",
                  alignItems: "center",
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateFilter
                    startDateValue={startDateValue}
                    setStartDateValue={setStartDateValue}
                    endDateValue={endDateValue}
                    setEndDateValue={setEndDateValue}
                    setIsRefereshData={setIsDataFiltered}
                    loading={isLoading}
                  />
                </LocalizationProvider>
                <Button
                  variant="outlined"
                  sx={{
                    color: "#1D85C6",
                    border: "1px solid #1D85C6",
                    ":hover": {
                      border: "1px solid #1D85C6",
                      color: "black",
                    },
                  }}
                  size="small"
                  onClick={() => setIsExportButtonClicked(true)}
                >
                  Export
                </Button>
                <Button
                  onClick={() => history.push("/schedule-booking/new booking")}
                  variant="contained"
                  size="medium"
                  sx={{
                    backgroundColor: "#44B150",
                    ":hover": {
                      backgroundColor: "#44B150",
                      opacity: 0.8,
                    },
                    boxShadow: "none",
                    fontFamily: "Montserrat",
                    fontSize: "12px",
                    padding: "8px 20px",
                    textTransform: "none",
                    minWidth: "110px",
                    marginLeft: "12px",
                  }}
                >
                  Add New Booking
                </Button>
              </Box>
            </Box>
            <Records
              data={currentRecords}
              headers={SHIFT_TITLE}
              isLoading={isLoading}
            />
            <Box
              sx={{
                position: "sticky",
                bottom: 0,
                background: "white",
                zIndex: 1,
                border: "none !important",
                borderTop: "none !important",
                borderBottom: "none !important",
                "&::before": {
                  display: "none",
                },
                "&::after": {
                  display: "none",
                },
              }}
            >
              <CommonTablePagination
                page={page}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                setPage={setPage}
                filteredData={filteredData}
                styling={{
                  display: "flex",
                  justifyContent: "flex-end",
                  border: "none",
                  borderTop: "none",
                  borderBottom: "none",
                  "& .MuiTablePagination-root": {
                    border: "none",
                    borderTop: "none",
                    borderBottom: "none",
                    "&::before": {
                      display: "none",
                    },
                    "&::after": {
                      display: "none",
                    },
                  },
                  "& .MuiTablePagination-toolbar": {
                    border: "none",
                    borderTop: "none",
                    borderBottom: "none",
                    "&::before": {
                      display: "none",
                    },
                    "&::after": {
                      display: "none",
                    },
                  },
                  "& .MuiTablePagination-spacer": {
                    border: "none",
                  },
                }}
              />
            </Box>
          </Paper>
        </div>
      </Box>
      {isExportButtonClicked && (
        <Modal
          setIsExportButtonClicked={setIsExportButtonClicked}
          type="bookingRequests"
        />
      )}
      {isExportButtonClicked && <div className="add-route-fullcontainer"></div>}
    </div>
  );
}

export default PreviousBookings;
